import config from "../config";

export const getUserData = async (username) => {
  const response = await fetch(
    `${config.apiEndpoint}/users/${username}?include=avatars,website&include_inactive=1`
  );
  return await response.json();
};
